(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tt/assets/javascripts/services/fetch-draws.js') >= 0) return;  svs.modules.push('/modules/tt/assets/javascripts/services/fetch-draws.js');
"use strict";


const normalizeDraws = svs.tt.utils.normalizeDraws;
const isTopptipset = svs.utils.products.helpers.isTopptipset;
const _svs$components$lbUti = svs.components.lbUtils.apiProxy,
  ApiProxy = _svs$components$lbUti.ApiProxy,
  http = _svs$components$lbUti.http,
  featureToggle = _svs$components$lbUti.featureToggle;
const fetchDraws = async productSetting => {
  if (!productSetting) {
    return {
      draws: [],
      availableSports: []
    };
  }
  const customHandler = http.get("/draw/1/:product/draws", _ref => {
    let data = _ref.data;
    return data;
  }, {
    config: {
      shouldUseCloud: async () => {
        const isEnabled = await featureToggle('ft-use-draw-proxy-bomben-cloud-api', {
          req: undefined
        });
        return isEnabled;
      },
      allowedProducts: ['bomben'],
      cloudEndpointTemplate: '/v1/:product/draws'
    }
  });
  const apiProxy = new ApiProxy([customHandler]);
  let productName;
  if (isTopptipset(productSetting.productType)) {
    productName = 'topptipsetfamily';
  } else {
    productName = productSetting.productType;
  }
  const response = await apiProxy.fetch("/draw/1/".concat(productName, "/draws"), {
    method: 'GET',
    req: undefined
  });
  const page = normalizeDraws(response);
  return {
    draws: page.draws,
    availableSports: page.availableSports
  };
};
setGlobal('svs.tt.services.fetchDraws', fetchDraws);

 })(window);